import { Layout, notification } from "antd";
import axios from "axios";
import PropTypes from "prop-types";
import { useContext, useEffect, useState } from "react";
import { useMutation } from "react-query";
import { Outlet, useNavigate } from "react-router-dom";
import { AppContext } from "../AppContext";
import NavBar from "../components/NavBar";
import tr from "../i18n";

const { Content, Header } = Layout;

export default function MainContainer({ toggleSideBar, setToggleSideBar }) {
  const navigate = useNavigate();
  const [user, setUser] = useState(null);
  const { setToken } = useContext(AppContext);

  useEffect(() => {
    const token = localStorage.getItem("token");
    const userObj = localStorage.getItem("user");
    const userSettings = localStorage.getItem("settings");
    setUser({ ...JSON.parse(userObj), settings: JSON.parse(userSettings) });

    if (!token) {
      navigate("/login");
    }
  }, [navigate]);

  const logoutUser = useMutation(
    () => {
      return axios.post(`${process.env.REACT_APP_GARDENER_API_END_POINT}/auth/logout`);
    },
    {
      onSuccess: () => {
        notification.success({
          message: tr("User logged out successfully"),
        });
      },
      onError: (error) => {
        notification.error({
          message: tr("Something went wrong while logging out user"),
        });
      },
    }
  );

  const onLogout = async () => {
    await logoutUser.mutateAsync();
    localStorage.removeItem("token");
    setToken(null);
    localStorage.removeItem("settings");
    localStorage.removeItem("user");
    navigate("/login");
  };

  return (
    <>
      <Header style={{ alignItems: "center", display: "flex", height: 48, paddingInline: 10, position: "sticky", top: 0, zIndex: 1001 }}>
        <NavBar headerTitle={tr("Central Irrigation Management System")} onLogOut={onLogout} userImage={user?.settings?.logoUrl} />
      </Header>

      <Outlet />
    </>
  );
}

MainContainer.propTypes = {
  children: PropTypes.any,
};
